import { TFlagChangeRequestStatus } from 'partner360/models/partnerFlagRequests/TFlagChangeRequestStatus'

export const isActiveFlagRequest = (requestStatus?: TFlagChangeRequestStatus | null) => {
  return requestStatus === 'New' || requestStatus === 'Wip'
}
